import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { guidFor } from '@ember/object/internals';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{! Args:\n    @value           — valore corrente (stringa)\n    @onValueChange   — callback(newValue) quando il contenuto cambia\n    @applicationController — opzionale, per il link \"testi predefiniti\"\n    @custom_field    — opzionale, per il link \"testi predefiniti\"\n    @ariaLabel       — opzionale, nome del campo per il box idle (role=textbox)\n}}\n{{#if this.editCode}}\n  <Textarea\n    @value={{this._localValue}}\n    rows=\'4\' data-test-on-textarea-input {{did-update this.syncValue @value}}\n    {{on \'input\' this.onTextareaInput}}\n  />\n{{else}}\n  {{! Mount the editor directly. The old deferred-mount (\"idle\" stand-in until the\n      field was pressed) lost data on cards with several editors: a field whose Quill\n      was never initialized could not hand its value to the save. Always mounting is\n      slower to render but never drops content. }}\n  <BbEditor\n    @id={{this.elementId}}\n    @value={{@value}}\n    @setValue={{@onValueChange}}\n  />\n{{/if}}\n\n{{#unless @hideExtraTools}}\n  <span class=\'open-cf-canned-response\'>\n    <a data-test-toggle-edit-code {{on \'click\' this.toggleEditCode}}>\n      &lt; code &gt;\n    </a>\n    {{#if @applicationController}}\n      |\n      <a data-test-set-canned-custom-field {{on \'click\' this.setCannedCustomField}}>\n        {{t \'predefined texts\'}}\n      </a>\n    {{/if}}\n  </span>\n{{/unless}}\n");

var _class, _descriptor, _descriptor2;
let CfAdvancedTextareaComponent = (_class = class CfAdvancedTextareaComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    // ─── Stato locale ─────────────────────────────────────────────────────────
    _initializerDefineProperty(this, "editCode", _descriptor, this);
    // Copia locale del valore per il binding della <Textarea> in modalità codice
    _initializerDefineProperty(this, "_localValue", _descriptor2, this);
    this._localValue = args.value ?? '';
  }

  // ─── ID univoco per BbEditor ──────────────────────────────────────────────

  get elementId() {
    return guidFor(this);
  }

  // ─── Sync quando il parent aggiorna @value esternamente ───────────────────

  syncValue() {
    this._localValue = this.args.value ?? '';
  }

  // ─── Handlers ─────────────────────────────────────────────────────────────

  onTextareaInput(event) {
    this._localValue = event.target.value;
    this.args.onValueChange?.(this._localValue);
  }
  toggleEditCode(e) {
    e.preventDefault();
    // Sync _localValue from @value before switching to code mode
    // so the textarea shows the latest HTML (BbEditor may have updated @value externally)
    if (!this.editCode) {
      this._localValue = this.args.value ?? '';
    }
    this.editCode = !this.editCode;
  }

  // Imposta il canned response sull'applicationController (se passato)
  setCannedCustomField(e) {
    e.preventDefault();
    if (this.args.applicationController && this.args.custom_field) {
      set(this.args.applicationController, 'cannedCustomField', this.args.custom_field);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "editCode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_localValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "syncValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "syncValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTextareaInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTextareaInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleEditCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEditCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCannedCustomField", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCannedCustomField"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, CfAdvancedTextareaComponent);

export { CfAdvancedTextareaComponent as default };
//# sourceMappingURL=cf-advanced-textarea.js.map
